/**
 * Represents an Image
 */
export class Image {

	public id: string;

	public url: string;
}
